import { Map as ImmutableMap } from 'immutable';
import queryString from 'query-string';

import { DEV_CENTER_CLI_APP_ID } from '~/constants';
import { DRILLOUT_SEGMENT, SEGMENTS } from '~/constants/segment';

export const getAppIdentifier = ({ appKey, version, isLocalDebugMode }) => {
  if (!appKey) return '';
  const appIdentifier = appKey.replace(/\./g, '_');
  return isLocalDebugMode ? appIdentifier : `${appIdentifier}-${version}`;
};
export const isAppMaximized = (query, appId = DEV_CENTER_CLI_APP_ID) =>
  appId === +query?.maximizeDC;

export function createDevCenterRouter(reactRouter) {
  return {
    push: params => {
      if (typeof params === 'string') {
        reactRouter.push(params);
      } else {
        const qs = params.query ? queryString.stringify(params.query) : '';
        const search = qs ? `?${qs}` : undefined;
        reactRouter.push({ pathname: params.pathname, search });
      }
    },
    location: {
      pathname: reactRouter?.location?.pathname,
      query: queryString.parse(reactRouter?.location?.search),
    },
  };
}

export const getTimestampFromQuery = query =>
  query ? +(query.split('#')[2] || '').replace('}', '') : undefined;

export const getAppName = app => app?.name ?? app?.package?.manifest?.application?.name ?? '';

export const isDevCenterApp = app => (app?.platform || app?.app?.platform) === 'dev_center';

export const getAppSegment = app => {
  if (!app) {
    return SEGMENTS.DRILLING;
  }
  const segmentFromAppSettings =
    app.settings instanceof ImmutableMap ? app.settings.get('segment') : app.settings?.segment;

  const segment = segmentFromAppSettings ?? app.segment?.[0];

  if (segment) {
    // TODO: Remove this special case once all Core Drillout apps are migrated to Intervention segment
    if (
      segment === SEGMENTS.COMPLETION &&
      app.app?.platform === 'core' &&
      app.category === DRILLOUT_SEGMENT
    ) {
      return DRILLOUT_SEGMENT;
    }
    return segment;
  }
  return segment ?? SEGMENTS.DRILLING;
};

export const isCorvaApp = app => app?.app_key?.split('.')?.[0] === 'corva';

// For the transition period, the default value is true
// After the transition - it'll be changed to false
export const isIsolationEnabledInPackageManifest = appPackage =>
  appPackage?.manifest?.settings?.enable_isolation ?? true;
